import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { MobileStrip, MobileTopButton, Actions, Tabs } from 'Components';
import { capitalToDashedLower } from 'helpers/regex';
import InvoicesListMobileItemList from './InvoicesListMobileItemList/InvoicesListMobileItemList';
import './InvoicesListMobile.css';

class InvoicesListMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedJob: undefined,
      selectedInvoiceNumber: undefined,
    };

    this.setInvoiceMobileState = this.setInvoiceMobileState.bind(this);
  }

  setInvoiceMobileState(state) {
    this.setState(state);
  }

  render() {
    const { selectedJob } = this.state;
    const job = (selectedJob &&
      <Fragment>
        <MobileTopButton onClick={() => this.setState({ selectedJob: undefined })} icon="chevron_left" text={`${i18n.t('invoices:Invoice')} ${this.state.selectedInvoiceNumber}`} />
        <div className="invoices-list-mobile__selected-job">
          {Object.entries(selectedJob).map(([k, v]) => (
            <div className={`invoices-list-mobile-selected-job__${capitalToDashedLower(k)}`}>
              {/* Adding 2 extra fields which are not exsist in invoiceJobs table API */}
              <h5>{
                {
                  ...this.props.invoiceJobs.keyPairs,
                  POAFENumber: i18n.t('invoices:POAFENumber'),
                  SiteLocation: i18n.t('invoices:Site Location'),
                }[k]
                }
              </h5>
              <span>{v}</span>
            </div>
          ))}
        </div>
      </Fragment>);

    const invoices = (
      <Fragment>
        <MobileStrip
          title={i18n.t('head:Invoices')}
          left="/supplies"
          right="/"
        />
        <div className="invoices-list-mobile__export-to-excel">
          <Actions.ExportToExcel onClick={this.props.downloadInvoices} />
        </div>
        <div className="invoices-mobile__tabs">
          <Tabs
            tabs={this.props.tabs}
            labels={this.props.tabs.map(tab => i18n.t(`invoices:${tab}`))}
            index={this.props.data.tabIndex}
            onClick={i => this.props.onTabClick(i)}
          />
        </div>
        <InvoicesListMobileItemList
          onMoreVertClick={this.props.onMoreVertClick}
          onMenuClick={this.props.onMenuClick}
          data={this.props.data.data}
          isGlobalSearch={this.props.isGlobalSearch}
          tabs={this.props.tabs}
          tabIndex={this.props.data.tabIndex}
          isLoading={this.props.data.isLoading}
          handleTrExpand={this.props.handleTrExpand}
          setInvoiceMobileState={this.setInvoiceMobileState}
          hasAccessToInvoices={this.props.hasAccessToInvoices}
        />
      </Fragment>
    );

    return (
      <div className="invoices-list-mobile">
        <div className={!this.state.selectedJob ? 'invoices-list-mobile__content--hide' : ''}>{ job }</div>
        <div className={this.state.selectedJob ? 'invoices-list-mobile__content--hide' : ''}>{ invoices }</div>
      </div>
    );
  }
}

InvoicesListMobile.propTypes = {
  onMoreVertClick: PropTypes.func,
  onMenuClick: PropTypes.func,
  handleTrExpand: PropTypes.func,
  onTabClick: PropTypes.func,
  isGlobalSearch: PropTypes.bool,
  hasAccessToInvoices: PropTypes.bool,
  tabs: PropTypes.arrayOf(PropTypes.string),
  invoiceJobs: PropTypes.shape({
    keyPairs: PropTypes.shape({}),
  }),
  data: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
    isLoading: PropTypes.bool,
    tabIndex: PropTypes.number,
  }),
  downloadInvoices: PropTypes.func,
};
export default InvoicesListMobile;



// WEBPACK FOOTER //
// ./src/containers/Invoices/InvoicesList/InvoicesListMobile/InvoicesListMobile.jsx